import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { Type } from 'lucide-react';
import { cn } from '@/lib/utils';

interface HeadlinePreviewMiniProps {
  headline: {
    text: string;
    color: string;
    fontFamily: string;
  };
  subheadline?: {
    text: string;
    color: string;
  };
  className?: string;
}

export const HeadlinePreviewMini: React.FC<HeadlinePreviewMiniProps> = ({
  headline,
  subheadline,
  className
}) => {
  useLanguage();
  return (
    <div data-theme-isolated
      className={cn(
        "flex flex-col items-center justify-center gap-1 p-3",
        className
      )}
    >
      {/* Headline text */}
      {headline.text ? (
        <span 
          className="text-sm font-semibold text-center line-clamp-2 leading-tight"
          style={{ 
            color: headline.color,
            fontFamily: headline.fontFamily 
          }}
        >
          {headline.text}
        </span>
      ) : (
        <div className="flex items-center gap-1.5 text-white/50">
          <Type className="h-4 w-4" />
          <span className="text-xs">{translateInterfaceText("Headline")}</span>
        </div>
      )}
      
      {/* Subheadline text */}
      {subheadline?.text && (
        <span 
          className="text-xs text-center opacity-80 line-clamp-1"
          style={{ color: subheadline.color }}
        >
          {subheadline.text}
        </span>
      )}
    </div>
  );
};
